import "./App.css";
import { ToastContainer } from "react-toastify";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Layout from "./app/common/Layout";
import Login from "./app/authentications/Login";
import RequireAuth from "./app/authentications/RequireAuth";
import ProductionScheduleSetting from "./app/features/scheduleFeed/ProductionScheduleSettings";
import ScheduleFeed from "./app/features/scheduleFeed/scheduleFeed";
import { useSelector } from "react-redux";
import { IUserInfo } from "./app/store/actions";
import { useEffect } from "react";
import Unauthorized from "./app/authentications/Unauthorized";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const authInfo: IUserInfo = useSelector(
    (state: any) => state.userAuthInfoState
  );

  const hasRole = (role: any) => authInfo?.roles?.includes(role);

  useEffect(() => {
    const publicRoutes = ["/cnc"];
    const isPublicRoute = publicRoutes.includes(location.pathname);
    console.log("Navigated to:", location.pathname);

    if ((!authInfo || !authInfo.roles?.length) && !isPublicRoute) {
      navigate("/login");
    }
    // If authenticated, and currently on a public route (like login), redirect to /schedule
    if (
      authInfo &&
      authInfo.roles?.length &&
      (location.pathname === "/login" || location.pathname === "/")
    ) {
      navigate("/schedule");
    }
  }, [authInfo, navigate, location.pathname]);

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route path="/" element={<Layout />}>
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route element={<RequireAuth />}>
            {(hasRole("user.admin") || hasRole("planning-manager")) && (
              <>
                <Route path="/schedule" element={<ScheduleFeed />} />
              </>
            )}

            {(hasRole("user.admin") || hasRole("production-manager")) && (
              <Route
                path="/production-schedule-setting"
                element={
                  <ProductionScheduleSetting></ProductionScheduleSetting>
                }
              />
            )}
          </Route>
        </Route>
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
